<!-- Действия над выбранной пометкой. -->
<template>
  <RecordListActions label="Действия с пометкой">
      <base-button :disabled="isSubmitting" type="button" icon="edit" variant="secondary" @click="$emit('edit')">
        Изменить
      </base-button>
  </RecordListActions>
</template>
<script>
import RecordListActions from "@/components/RecordList/Actions.vue";
export default {
  name: "VehicleRemarkDetailsActions",
  components: { RecordListActions },
  props: { isSubmitting: { type: Boolean, default: false } },
  emits: ["edit"],

};
</script>
